import { Component, Input, OnInit } from '@angular/core';
import { CommonMessagesService } from '../../../services/common-messages.service';

@Component({
  selector: 'app-clipboard-label',
  templateUrl: './clipboard-label.component.html',
  styleUrls: ['./clipboard-label.component.scss']
})
export class ClipboardLabelComponent implements OnInit {

  @Input() value: string;
  @Input() copiedValue: string;
  @Input() showIcon = true;

  constructor(public commonMessagesService: CommonMessagesService) { }

  ngOnInit(): void {}

}
